import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import {
  AgentEvalIncorrectOutcome,
  AgentEvalTest,
  AgentEvalTestResult,
} from '../agent-evals.types';

export interface TestResultDialogData {
  test: AgentEvalTest;
  result: AgentEvalTestResult;
}

@Component({
  selector: 'hour4u-admin-agent-eval-test-result-dialog',
  templateUrl: './test-result-dialog.component.html',
  styleUrls: ['./test-result-dialog.component.scss'],
})
export class AgentEvalTestResultDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<AgentEvalTestResultDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TestResultDialogData
  ) {}

  get result(): AgentEvalTestResult {
    return (this.data && this.data.result) || {};
  }

  get test(): AgentEvalTest {
    return this.data && this.data.test;
  }

  howScoreWasGiven(): string {
    const raw =
      this.result.how_score_was_given ||
      this.result.score_explanation ||
      this.result.reasoning ||
      'No score explanation returned for this run.';
    return this.stripProcessingMentions(raw);
  }

  suggestedToneClass(outcome: AgentEvalIncorrectOutcome): string {
    const human = ((outcome && outcome.human_review_outcome) || '').trim();
    const suggested = (
      (outcome && (outcome.eval_suggested_outcome || outcome.suggested_status)) ||
      ''
    ).trim();
    if (!human) {
      return 'ae-tone-neutral';
    }
    if (human.toLowerCase() === suggested.toLowerCase()) {
      return 'ae-tone-neutral';
    }
    return 'ae-fail';
  }

  private stripProcessingMentions(text: string): string {
    if (!text) {
      return text;
    }
    return text
      .replace(/\b(gpt-?\d(?:\.\d)?|openai|chatgpt|copilot|excel_single_gpt)\b/gi, '')
      .replace(/\s{2,}/g, ' ')
      .replace(/\s+([.,;:])/g, '$1')
      .trim();
  }

  close(): void {
    this.dialogRef.close();
  }
}
